module.exports = __webpack_public_path__ + "static/media/IUP_zast_L0.84fb4ee2.svg";